<rid-demo-page [title]="'Oefenvormen'" previousRoute="/">
  <div class="grid w-xl grid-cols-2 gap-4">
    <rid-button class="w-full" content="Klankbord" routerLink="syllabic-keyboard" variant="PRIMARY" />
    <rid-button class="w-full" content="Klankbord Plus" routerLink="syllabic-keyboard-plus" variant="PRIMARY" />
    <rid-button class="w-full" content="Lezen: basis" routerLink="reading-basis" variant="PRIMARY" />
    <rid-button class="w-full" content="Lezen: matrix" routerLink="reading-matrix" variant="PRIMARY" />
    <rid-button class="w-full" content="Lezen: expressie" routerLink="expression" variant="PRIMARY" />
    <rid-button class="w-full" content="Fonologisch bewustzijn" routerLink="phonetic-comprehension" variant="PRIMARY" />
    <rid-button class="w-full" content="Sorteren" routerLink="sorting" variant="PRIMARY" />
    <rid-button class="w-full" content="Morfemen" routerLink="morphemes" variant="PRIMARY" />
    <rid-button class="w-full" content="Dictee" routerLink="dictation" variant="PRIMARY" />
    <rid-button class="w-full" content="Algoritme" routerLink="algorithm" variant="PRIMARY" />
    <rid-button [disabled]="true" class="w-full" content="Games" variant="PRIMARY" />
    <rid-button class="w-full" content="Formule" routerLink="formule" variant="PRIMARY" />
  </div>
</rid-demo-page>
